import { css } from 'styled-components';
import { YELLOW_CBX, GRAY, BLACK } from '../../../constants/colors';

export default {
  button: ({ selected }) => `
    cursor: pointer;
    background-color: ${selected ? YELLOW_CBX : GRAY};
    padding: 1em;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0;
    outline: none;
    border: none;
    color: ${BLACK};
    &:focus{
        outline: none;
        border: none;
    }
    @media(min-width: 320px){
        width: 80px;
    }
    @media(min-width: 375px){
        width: 100px;
    }
    @media(min-width: 425px){
        width: 120px;
    }
    @(media: 768px){
        width: 150px;
    }
    ${({ selected }) => selected && `
      background-color: ${YELLOW_CBX};
    `}
  `,
  text: css`
    font-weight: bold;
    font-size: 1.5em;
  `,
};
